module.exports = __webpack_public_path__ + "img/link.1.4e5051ab.svg";